// extracted by mini-css-extract-plugin
export default {"container":"gl-z","blurb":"hl-z","links":"il-z"};